import { ReactNode } from 'react';
import Link from '../../common/Link';
import { TableColumn } from '../../common/Table';
import { MatchItem, MatchTeam } from '../../helpers/interfaces/match';

export const homeMatchsColumns: TableColumn<MatchItem>[] = [
  {
    id: "status",
    name: "Stato",
    data: "status",
    render: (data: any, index: number, row: MatchItem) => {
      return <i className={`fa fa-circle${data === 'da-giocare' ? '-o' : ''} ${data}`} />
    }
  },
  {
    id: "time",
    name: "Orario",
    data: "time"
  },
  {
    id: "team1",
    name: "Casa",
    data: "team1",
    render: (data: MatchTeam, index: number, row: MatchItem) => {
      return <Link
        href={`/societa/${data.id}`}
        title={data.description ? data.description : data.name}
      >
        {data.name}
      </Link>
    }
  },
  {
    id: "score",
    name: "Punteggio",
    data: "score",
    default: "-",
  },
  {
    id: "team2",
    name: "Trasferta",
    data: "team2",
    render: (data: MatchTeam, index: number, row: MatchItem) => {
      return <Link
        href={`/societa/${data.id}`}
        title={data.description ? data.description : data.name}
      >
        {data.name}
      </Link>
    }
  }
];

export const homeMatchsMobileColumns: TableColumn<MatchItem>[] = [
  {
    id: "time_status",
    name: "Time and status",
    data: null,
    render: (data: null, index: number, row: MatchItem): ReactNode => {
      return <>
        {row['time']}
        <br />
        <i className={`fa fa-circle${row['status'] === 'da-giocare' ? '-o' : ''} ${row['status']}`} />
      </>
    }
  },
  {
    id: "teams",
    name: "Teams",
    data: null,
    render: (data: null, index: number, row: MatchItem): ReactNode => {
      return <>
        {row['team1']['name']}
        <br />
        {row['team2']['name']}
      </>
    }
  },
  {
    id: "score",
    name: "Score",
    data: "score",
    render: (data: string, index: number, row: MatchItem): ReactNode => {
      const scoreSplit = data !== null && data !== '' ? data.split('-') : ['-', '-'];
      const houseScore = scoreSplit[0] ? scoreSplit[0] : '-';
      const transferScore = scoreSplit[1] ? scoreSplit[1] : '-';

      return <>
        {houseScore}
        <br />
        {transferScore}
      </>
    }
  },
]
